import { Chips } from 'components/Chips/Chips'
import { TYPOGRAPHY_WEIGHT, Typography } from 'components/Typography'
import { TBusinessRepresentative } from './types'
import { getFullName } from 'helper/common'
import { useMemo } from 'react'

export const RepresentativeItem = ({
  representative
}: {
  representative: TBusinessRepresentative
}) => {
  const representativeType = useMemo(() => {
    if (representative.is_owner) {
      return `Owner of ${representative.ownership_percentage}%`
    }
    if (representative.is_controller) {
      return 'Controller'
    }
    return undefined
  }, [representative])

  const representativeJobTitle = useMemo(() => {
    if (representative.is_controller) {
      return representative.job_title
    }
    return undefined
  }, [representative])

  return (
    <div className="column p-8 business-account-details__representative-item gap-8">
      <div className="row gap-8">
        <Typography.Body1 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
          {getFullName(representative.first_name, representative.last_name)}
        </Typography.Body1>
        {representativeType && (
          <Chips closable={false} grey>
            {representativeType}
          </Chips>
        )}
      </div>
      {representativeJobTitle && (
        <Typography.Body2 className="grey-text">
          {representativeJobTitle}
        </Typography.Body2>
      )}
    </div>
  )
}
